import React, {FC} from 'react';
import {provider, useInstance} from 'react-ioc';
import {BrowserRouter as Router, Navigate, Route, Routes,} from 'react-router-dom';
import {YMInitializer} from 'react-yandex-metrika';
import {ApolloClient, ApolloProvider} from '@apollo/client';
import {ConfigProvider} from 'antd';
import ru_RU from 'antd/locale/ru_RU';
import {observer} from 'mobx-react-lite';

import 'dayjs/locale/ru';

import {Metrika} from '../components/Metrika';
import ScrollToTop from '../components/ScrollToTop';
import {
    INDEX,
    NOT_FOUND,
} from '../config/routes';
import ApolloClientDI from '../model/graphql/ApolloClientDI';
import StoreDI from '../model/store/StoreDI';
import Index from '../pages/Index/Index';
import NotFound from '../pages/NotFound';

import './App.scss';

const App: FC = () => {

    const apolloClient = useInstance(ApolloClient);

    return (
        <ConfigProvider locale={ru_RU} theme={{
            // algorithm: theme.darkAlgorithm,
            token: {
                colorPrimary: '#A7FC00',
                borderRadius: 10,
            },
        }}>
            <ApolloProvider client={apolloClient}>
                <Router>
                    <ScrollToTop/>
                    <YMInitializer accounts={[103742107]}/>
                    <Metrika/>

                    <Routes>
                        <Route path={INDEX} element={<Index/>}/>
                        <Route path="*" element={<Navigate to={INDEX}/>}/>
                        <Route path={NOT_FOUND} element={<NotFound/>}/>
                    </Routes>
                </Router>
            </ApolloProvider>
        </ConfigProvider>
);
};

export default provider(
StoreDI(),
ApolloClientDI(),
)(observer(App));
